export default function cidToUrl(cid: string): string | undefined {
  if (!cid) return undefined;

  return `https://dissrup.infura-ipfs.io/ipfs/${cid}`;
}
